import React, {useContext, useEffect, useState} from 'react'
import {Form, AutoComplete, notification} from "antd"
import {RecipeConText} from "../../../../../context/RecipeContext";
import {getRecipeCodes} from "../../../../../services/serviceRecipe";


const RecipeCode = () => {
    const {recipeAbstract} = useContext(RecipeConText);
    const [abstractState, setAbstractState] = recipeAbstract;
    const [recipeCodes, setRecipeCodes] = useState([]);
    const [form] = Form.useForm();

    const handleCodeChange = (val) => {
        let mockAbstract = Object.assign({}, abstractState);
        const hasProperty = mockAbstract.hasOwnProperty('recipeCode');

        if (hasProperty && !val) delete mockAbstract.recipeCode;
        if (val) mockAbstract.recipeCode = val;

        setAbstractState(mockAbstract);
    }

    useEffect(() => {
        getRecipeCodes()
            .then(({data}) => {
                const autoCompleteData = data
                    .map(({c: recipeCode}, i) => ({value: recipeCode, key: `recipe-code-${i}`}))
                setRecipeCodes(autoCompleteData);
            });
    }, [])

    const onBlur = ({target}) => {
        const val = target.value.toLocaleLowerCase('tr') || '';
        let hasSameCode = recipeCodes.filter(({value}) => value.toLocaleLowerCase('tr') === val);

        if (hasSameCode.length) {
            openNotification();
            handleCodeChange('')
            form.setFieldsValue({recipeCode: ''});
            return;
        }
        handleCodeChange(val)
    };

    const filterOption = (inputValue, option) => option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
    const openNotification = () => {
        notification.error({
            message: 'Reçete Kod Hatası',
            description:
                'Reçete Kodu, Önceden kayı edilen kodlar ile aynı olamaz. Reçete kodu otomatik olarak temizlenecektir'
        });
    };

    return(
        <React.Fragment>
            <Form
                form={form}
                labelAlign={'left'}
                labelCol={{span: 6}}
                wrapperCol={{span: 16}}
            >
                <Form.Item
                    className={'font-bold'}
                    label={'Reçete Kodu'}
                    name={'recipeCode'}
                >
                    <AutoComplete
                        status=""
                        options={recipeCodes}
                        onBlur={onBlur}
                        filterOption={filterOption}
                    />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default RecipeCode